export const loadDatadogRum = async () => {
  const { datadogRum } = await import('@datadog/browser-rum')

  return datadogRum
}
